module.exports = __webpack_public_path__ + "static/media/gallery05.93c557dd.jpg";